import { ResourceEnum, RoutePaths, ScopeEnum } from "config";

export const routeToResourceMap = {
  [RoutePaths.QUANT_ALERTS]: ResourceEnum.QuantAlerts,
  [RoutePaths.QUANT_CONSUMERS]: ResourceEnum.AuthApiConsumer,
  [RoutePaths.QUANT_ACCOUNTS]: ResourceEnum.QuantTradingPerformanceAccount,
  [RoutePaths.QUANT_DASHBOARD]: ResourceEnum.QuantTradingPerformanceAccount,
  [RoutePaths.USER_MANAGEMENT]: ResourceEnum.User,
  [RoutePaths.PERMISSION_MANAGEMENT]: ResourceEnum.AuthPermissionManager,
  [RoutePaths.INVESTMENT_LIBRARY_SOURCE_EXCHANGE]: ResourceEnum.SourceExchange,
  [RoutePaths.INVESTMENT_LIBRARY_TAG]: ResourceEnum.Tag,
  [RoutePaths.INVESTMENT_LIBRARY_DOCUMENT]: ResourceEnum.DocumentList,
  [RoutePaths.INVESTMENT_LIBRARY_PRODUCT_FUND]: ResourceEnum.ProductFund,
  [RoutePaths.INVESTMENT_LIBRARY_NOTE_TYPE]: ResourceEnum.NoteType,
  [RoutePaths.INVESTMENT_DATABASE]: ResourceEnum.InvestorProfile,
  [RoutePaths.FINANCE_CAPITAL_MOVEMENT]: ResourceEnum.CapitalMovement,
  [RoutePaths.FINANCE_CAPITAL_MOVEMENT_DIVIDEND]:
    ResourceEnum.CapitalMovementDividend,
  [RoutePaths.REPORTING]: ResourceEnum.InvestmentData,
  [RoutePaths.NOTIFICATION_SETTINGS]: ResourceEnum.NotificationSettings,
  [RoutePaths.EXPECTED_CONVERSION]: ResourceEnum.LeadConversionExpectation,
  [RoutePaths.PRODUCT_FUND_SERIES]: ResourceEnum.ProductFundSeries,
  [RoutePaths.WESTEROS_LIBRARY_TAGS]: ResourceEnum.WesterosTag,
  [RoutePaths.WESTEROS_LIBRARY_DOCUMENT_LIST]:
    ResourceEnum.WesterosDocumentList,
  [RoutePaths.WESTEROS_LIBRARY_NOTE_TYPE]: ResourceEnum.WesterosNoteType,
  [RoutePaths.WESTEROS_LIBRARY_SERVICE]: ResourceEnum.WesterosService,
  [RoutePaths.WESTEROS_PWM_LIBRARY_DOCUMENT_LIST]:
    ResourceEnum.WesterosPwmDocumentList,
  [RoutePaths.WESTEROS_PWM_LIBRARY_NOTE_TYPE]: ResourceEnum.WesterosPwmNoteType,
  [RoutePaths.WESTEROS_PWM_LIBRARY_EXCHANGE_ITEM]:
    ResourceEnum.WesterosPwmExchangeItem,
  [RoutePaths.WESTEROS_PWM_LIBRARY_STRATEGY_ITEM]:
    ResourceEnum.WesterosPwmStrategyItem,
  [RoutePaths.WESTEROS_PWM_PROFILE]: ResourceEnum.WesterosPwmProfile,
  [RoutePaths.WESTEROS_PWM_TRADING]: ResourceEnum.WesterosPwmTrading,
  [RoutePaths.WESTEROS_PWM_EXCHANGE]: ResourceEnum.WesterosPwmExchange,
  [RoutePaths.WESTEROS_PWM_STRATEGY]: ResourceEnum.WesterosPwmStrategy,
  [RoutePaths.WESTEROS_PWM_PROFILE_REPORT]:
    ResourceEnum.WesterosPwmProfileReport,
  [RoutePaths.WESTEROS_CLIENT_DATABASE]: ResourceEnum.WesterosClientProfile,
  [RoutePaths.ADVISORY_PROJECT]: ResourceEnum.AdvisoryProject,
  [RoutePaths.CAPITAL_INTRODUCER_PROFILES]: ResourceEnum.LinkAgentProfile,
  [RoutePaths.WEEKLY_UPDATES]: ResourceEnum.WeeklyUpdate,
  [RoutePaths.ANNOUNCEMENTS]: ResourceEnum.Announcement,
  [RoutePaths.UPCOMING_EVENTS]: ResourceEnum.UpcomingEvent,
  [RoutePaths.STATEMENTS]: ResourceEnum.Statement,
  [RoutePaths.REPORTS]: ResourceEnum.Report,
  [RoutePaths.STATEMENT_TYPE]: ResourceEnum.StatementType,
  [RoutePaths.REPORT_TYPE]: ResourceEnum.ReportType,
  [RoutePaths.EMAILS]: ResourceEnum.EmailHistory,
  [RoutePaths.EMAIL_SEND_EMAIL]: ResourceEnum.InvestorProfile,
  [RoutePaths.CAPITAL_INTRODUCER_PAYOUTS]: ResourceEnum.LinkAgentPayout,
  [RoutePaths.CAPITAL_INTRODUCER_REPORTS]: ResourceEnum.LinkAgentReport,
  [RoutePaths.CAPITAL_INTRODUCER_KPI_REPORT]: ResourceEnum.LinkAgentKpiData,
  [RoutePaths.EMAIL_TEMPLATES]: ResourceEnum.EmailTemplate,
  [RoutePaths.VENTURE_PROJECT_PROFILE]: ResourceEnum.ProjectProfile,
  [RoutePaths.VENTURE_DASHBOARD]: ResourceEnum.VentureDashboard,
  [RoutePaths.VENTURE_VALUATION_CONTROL]: ResourceEnum.VentureValuationControl,
  [RoutePaths.VENTURE_ASSET_ATTRIBUTION]: ResourceEnum.VentureAssetAttribution,
  [RoutePaths.VENTURE_TGE_CALENDAR]: ResourceEnum.VentureAssetAttribution,
  [RoutePaths.VENTURE_CONTACT]: ResourceEnum.VentureContact,
  [RoutePaths.VENTURE_KPI]: ResourceEnum.VentureKpi,
  [RoutePaths.VENTURE_PORTFOLIO_CONTROL]: ResourceEnum.VenturePortfolioControl,
  [RoutePaths.VENTURE_SNAPSHOTS]: ResourceEnum.VentureSnapshots,
  [RoutePaths.VENTURE_MODELING_TOKEN_MODELING]: ResourceEnum.ProjectProfile,
  [RoutePaths.VENTURE_MODELING_VESTING_MODELING]:
    ResourceEnum.VentureVestingModeling,
  [RoutePaths.VENTURE_LIBRARY_NOTE_TYPE]: ResourceEnum.VentureNoteType,
  [RoutePaths.VENTURE_LIBRARY_TAGS]: ResourceEnum.VentureTag,
  [RoutePaths.VENTURE_LIBRARY_DOCUMENT_LIST]: ResourceEnum.VentureDocumentList,
  [RoutePaths.VENTURE_LIBRARY_ORIGINATION_SOURCE]:
    ResourceEnum.VentureOriginationSource,
  [RoutePaths.VENTURE_LIBRARY_BLOCKCHAIN_LIST]: ResourceEnum.VentureBlockchain,
  [RoutePaths.VENTURE_LIBRARY_INVESTMENT_METHOD]:
    ResourceEnum.VentureInvestmentMethod,
  [RoutePaths.VENTURE_LIBRARY_CONTACT_TYPE]: ResourceEnum.VentureContactType,
  [RoutePaths.VENTURE_LIBRARY_SECTOR]: ResourceEnum.VentureSector,
  [RoutePaths.SYSTEM_TASK_MANAGEMENT_TASK]:
    ResourceEnum.SystemTaskManagementTask,
  [RoutePaths.SYSTEM_TASK_MANAGEMENT_RECURRING_TASK]:
    ResourceEnum.SystemTaskManagementRecurringTask,
  [RoutePaths.SYSTEM_TASK_MANAGEMENT_TASK_TYPE]:
    ResourceEnum.SystemTaskManagementTaskType,
  [RoutePaths.SYSTEM_TASK_MANAGEMENT_NOTE_TYPE]:
    ResourceEnum.SystemTaskManagementTaskNoteType,
  [RoutePaths.SYSTEM_TASK_MANAGEMENT_TASK_REPORTING]:
    ResourceEnum.SystemTaskManagementTaskReporting,
  [RoutePaths.SYSTEM_TASK_MANAGEMENT_REMIND]:
    ResourceEnum.SystemTaskManagementRemind,
  [RoutePaths.SYSTEM_TASK_MANAGEMENT_REMIND_TYPE]:
    ResourceEnum.SystemTaskManagementRemindType,
  [RoutePaths.ADVISORY_BUYER]: ResourceEnum.AdvisoryBuyer,
  [RoutePaths.ADVISORY_PURCHASE]: ResourceEnum.AdvisoryPurchase,
  [RoutePaths.ADVISORY_TRANCHE]: ResourceEnum.AdvisoryTranche,
  [RoutePaths.ADVISORY_EXIT_PLAN]: ResourceEnum.AdvisoryExitPlan,
  [RoutePaths.ADVISORY_DISTRIBUTION]: ResourceEnum.AdvisoryDistribution,
  [RoutePaths.ADVISORY_REPORT]: ResourceEnum.AdvisoryReport,
  [RoutePaths.ADVISORY_LIBRARY_FIREBLOCKS_WALLET]:
    ResourceEnum.FireblocksWallet,
  [RoutePaths.USER_EMPLOYEE_DASHBOARD]: ResourceEnum.EmployeeDashboard,
  [RoutePaths.HR_LIBRARY_DOCUMENT_LIST]: ResourceEnum.HrDocumentList,
  [RoutePaths.HR_EMPLOYEE]: ResourceEnum.HrEmployee,
  [RoutePaths.HR_EMPLOYEE_LEAVE]: ResourceEnum.HrEmployeeLeave,
  [RoutePaths.HR_EMPLOYEE_COMPENSATION]: ResourceEnum.HrEmployeeCompensation,
  [RoutePaths.HR_HOLIDAY_CALENDAR]: ResourceEnum.HrHolidayCalendar,
  [RoutePaths.HR_FINANCIAL_REPORT]: ResourceEnum.HrFinancialReport,
  [RoutePaths.HR_POINT_SYSTEM_QUANT_FUND_TIER]: ResourceEnum.HrQuantFundTier,
  [RoutePaths.HR_POINT_SYSTEM_QUANT_POINTS]: ResourceEnum.HrQuantPoints,
  [RoutePaths.HR_POINT_SYSTEM_QUANT_PERFORMANCE]:
    ResourceEnum.HrQuantPerformance,
  [RoutePaths.HR_POINT_SYSTEM_QUANT_DISTRIBUTION]:
    ResourceEnum.HrQuantDistributionHistory,
  [RoutePaths.HR_POINT_SYSTEM_VENTURE_POINTS]: ResourceEnum.HrVenturePoints,
  [RoutePaths.HR_POINT_SYSTEM_VENTURE_PERFORMANCE]: ResourceEnum.HrVenturePool,
  [RoutePaths.HR_POINT_SYSTEM_VENTURE_DISTRIBUTION]:
    ResourceEnum.HrVentureDistributionHistory,
  [RoutePaths.HR_POINT_SYSTEM_CAPITAL_FORMATION_TIER]:
    ResourceEnum.HrCapitalFormationTier,
  [RoutePaths.HR_POINT_SYSTEM_CAPITAL_FORMATION_DISTRIBUTION]:
    ResourceEnum.HrCapitalFormationDistributionHistory,
  [RoutePaths.FINANCE_DISTRIBUTION_MODELING]:
    ResourceEnum.FinanceDistributionModeling,
  [RoutePaths.FINANCE_DASHBOARD]: ResourceEnum.FinanceDashboard,
  [RoutePaths.FINANCE_ASSETS_FIREBLOCKS]: ResourceEnum.AssetsFireblocks,
  [RoutePaths.FINANCE_ASSETS_EXCHANGE]: ResourceEnum.AssetsAsset,
  [RoutePaths.FINANCE_ASSETS_EXCHANGE_TYPE]: ResourceEnum.AssetsExchangeType,
  [RoutePaths.FINANCE_ASSETS_LEGAL_ENTITIES]: ResourceEnum.FinanceLegalEntity,
  [RoutePaths.FINANCE_ASSETS_BANK_ACCOUNTS]: ResourceEnum.FinanceBankAccount,
  [RoutePaths.FINANCE_ASSETS_EXCHANGE_ACCOUNTS]: ResourceEnum.AssetsExchange,
  [RoutePaths.FINANCE_ASSETS_SNAPSHOTS]: ResourceEnum.Snapshot,
  [RoutePaths.INFRASTRUCTURE_ACCOUNTS]: ResourceEnum.InfrastructureAccount,
  [RoutePaths.INFRASTRUCTURE_SYSTEM_TASKS]:
    ResourceEnum.InfrastructureSystemTask,
  [RoutePaths.INFRASTRUCTURE_DASHBOARD]: ResourceEnum.InfrastructureCost,
  [RoutePaths.CAPITAL_FORMATION_DASHBOARD]:
    ResourceEnum.CapitalFormationDashboard,
  [RoutePaths.CAPITAL_FORMATION_LEAD_MAPPING]:
    ResourceEnum.CapitalFormationLeadMapping,
  [RoutePaths.CAPITAL_FORMATION_LEAD_REPORTING]:
    ResourceEnum.CapitalFormationInvestorData,
  [RoutePaths.CAPITAL_FORMATION_KPI_PERFORMANCE]:
    ResourceEnum.CapitalFormationKpiData,
  [RoutePaths.CAPITAL_FORMATION_CI_RESOURCES]: ResourceEnum.Resource,
  [RoutePaths.CONVERSION_GRADING]:
    ResourceEnum.CapitalFormationConversionGrading,
  [RoutePaths.CAPITAL_FORMATION_SNAPSHOTS]:
    ResourceEnum.CapitalFormationSnapshots,
  [RoutePaths.CAPITAL_FORMATION_FUND_RAISING]:
    ResourceEnum.CapitalFormationCommitmentTracking,
  [RoutePaths.CAPITAL_FORMATION_CRST_INVESTOR_DATABASE]:
    ResourceEnum.CapitalFormationCrstDatabase,
  [RoutePaths.AI_AGENT_LEADS]: ResourceEnum.LeadAgentLead,
  [RoutePaths.FINANCE_INTRA_GROUP_LOANS]: ResourceEnum.FinanceIntraGroupLoan,
} as Record<RoutePaths, ResourceEnum>;

export const routeToSpecificScopeMap = {
  [RoutePaths.EMAIL_SEND_EMAIL]: ScopeEnum.SendEmail,
} as Record<RoutePaths, ScopeEnum>;
